// extracted by mini-css-extract-plugin
export default {"defaultLogo":"IconInstitution_defaultLogo__XBicI","logo":"IconInstitution_logo__c-nMx"};